import React, { useState } from "react";
import { countryCodes } from "./countryCodes";

const CountryCodeModal = ({ isOpen, onClose, onSelect }) => {
  const [search, setSearch] = useState("");

  const filtered = countryCodes.filter(
    (c) =>
      c.name.toLowerCase().includes(search.toLowerCase()) ||
      c.dial_code.includes(search)
  );

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <input
            type="text"
            placeholder="Search country or code"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <button onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          {filtered.map((c) => (
            <div
              key={c.code}
              className="modal-country"
              onClick={() => {
                onSelect(c.dial_code);
                onClose();
              }}
            >
              <span>{c.flag}</span>
              <span>{c.name}</span>
              <span className="dial">{c.dial_code}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CountryCodeModal;
